import { useMutation, useQueryClient } from "@tanstack/vue-query";

import { useServices } from "@/configuration/plugins/app/app-provider.configuration";
import { InternalMutationKeys } from "@/data/api/kili/internal/internal-query-keys";
import { SitesQueryKeys } from "@/data/api/kili/sites/sites-query-keys";
import { SiteProgrammingRangeQueryKeys } from "@/data/api/v4b/site-programming-range/site-programming-range-query-keys";
import { ProgramId, V4HSiteId } from "@/data/common/ids";
import { UpdateProgramRequest } from "@/domains/v4b/program/program-update.types";

export type TRenameProgramCommand = {
  siteId: V4HSiteId;
  programId: ProgramId;
  request: UpdateProgramRequest;
};

export function useUpdateSiteProgramMutation() {
  const v4bClientSdk = useServices().v4b.clientSdk;
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: InternalMutationKeys.renameSiteProgram(),
    mutationFn: async ({ programId, request }: TRenameProgramCommand) => {
      await v4bClientSdk.siteProgram.updateProgram(programId, request);
    },
    onSettled: (_data, _error, command) => {
      queryClient.removeQueries({
        queryKey: SitesQueryKeys.programs(command.siteId),
      });

      queryClient.removeQueries({
        queryKey: SiteProgrammingRangeQueryKeys.findPlanning(command.siteId),
      });

      queryClient.invalidateQueries({
        queryKey: SitesQueryKeys.programDetails(command.siteId, command.programId),
      });
    },
  });
}
